var map = {
	"./arrow.svg": 55102,
	"./bloodPressure.svg": 1521,
	"./calendar.svg": 63850,
	"./facialSkinAge.svg": 30036,
	"./general-wellness-2.svg": 13341,
	"./general-wellness.svg": 88700,
	"./generalWellness.svg": 67988,
	"./heartRate.svg": 82396,
	"./hrvSdnn.svg": 14532,
	"./ibi.svg": 1618,
	"./lightbulb.svg": 61355,
	"./location.svg": 92310,
	"./mannings_logo.svg": 64604,
	"./respiratoryRate.svg": 34355,
	"./spo2.svg": 22612,
	"./stress-top.svg": 53843,
	"./stress.svg": 97416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70986;